module.exports = __webpack_public_path__ + "static/img/ndvi_10.f1c61d4f.jpg";